<div class="c-content c-content--wrapper" [ngClass]="{'c-content--xxl': !vm.loading && ((!vm.bookings?.length && vm.isAvailable) || !vm.isAvailable), 'u-no-p@up-to-md': vm.loading || (vm.bookings?.length && vm.isAvailable)}" [ngStyle]="(vm.loading || !vm.bookings?.length) && {'min-height': '160px'}" [ngSwitch]="vm.isAvailable">
	<div *ngSwitchCase="true">
		<table-bookings-instant [bookings]="vm.bookings" *ngIf="!vm.loading && vm.bookings?.length"></table-bookings-instant>
		<p class="c-text c-text--gray c-text--center c-text--md@up-to-md c-text--lg u-ost-md@up-to-md u-osb-md@up-to-md" *ngIf="!vm.loading && !vm.bookings?.length">{{ 'Booking.Other.NoContent' | translate }}</p>
	</div>
	<div *ngSwitchDefault>
		<div class="o-grid">
			<div class="o-grid__cell o-grid__cell--center-h">
				<p class="c-text c-text--gray c-text--center c-text--md@up-to-md c-text--lg u-osb-md u-ost-md@up-to-md">{{ 'Booking.Instant.Online_Status_Required' | translate }}</p>
				<button id="toggleAvailabilityStatusButton" type="button" class="c-button c-button--s1 c-button--narrow u-osb-md@up-to-md" (click)="vm.toggleAvailabilityStatus(true)">{{ 'Booking.Instant.Toggle_Online' | translate }}</button>
			</div>
		</div>
	</div>
	<loader-overlay *ngIf="vm.loading"></loader-overlay>
</div>
